import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMessages(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M11.139 14.667H18V6H6v10.764l3.35-1.675a3.999 3.999 0 0 1 1.789-.422Zm-.895 2.21a2 2 0 0 1 .895-.21H18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v14l6.244-3.122ZM8 12a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1-4a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H9Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
